import { container, TYPES } from  "@/inversifyconfig/container.config";

//interfaces
import { IHttpRequest } from  "@/interfaces/IHttp";
import { IThriveSpotlightData } from  "@/interfaces/spotlight";


const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

export async function getSpotlightData(signal?: AbortSignal): Promise<IThriveSpotlightData> {
    const res = await http.get(`spotlight`, { signal, validateStatus: (status:any) => status < 400});
    
    if (res.data) {
        return res.data;
    }

    throw new Error(`Couldn't get spotlight data`);
}